import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';
const getSupplySubCategoriesQuery = gql`query get_supply_sub_categories{
  supply_sub_categories(where: {status: {_eq: "ACTIVE"}}, order_by: {name: asc}){
    id
    name
    created_at
    updated_at
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSupplySubCategoriesService {

  constructor(private apollo: Apollo) { }

  /* -------------------------- Get Supply Categories ------------------------- */
  getSupplySubCategories(){
    return this.apollo.use('external').query({
      query: getSupplySubCategoriesQuery
    }).pipe(pluck('data', 'supply_sub_categories'))
  }
}
